import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { GlobalIRSatelliteCompositeSvgComponent } from './global-ir-satellite-composite-svg/global-ir-satellite-composite-legend-svg';

export const GLOBAL_IR_SATELLITE_COMPOSITE_LEGEND: TwcLegendParams = {
  title: 'GLOBAL IR SATELLITE',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: GlobalIRSatelliteCompositeSvgComponent },
  legendComponent: TwcLegendComponent
};
